export enum GpsListType {
    PendingShip = 1,
    ShippedToMC = 2,
    PendingGps = 8,
    NeedsActivation = 3,
    InProcess = 4,
    ReturnToNKR = 5,
    PendingNKRReceipt = 6,
    ReceivedByNKR = 7
}